// extracted by mini-css-extract-plugin
export var body = "videoOverlay-module--body--6vkDi";
export var chapterItem = "videoOverlay-module--chapter-item--JcU+d";
export var chapterItemActive = "videoOverlay-module--chapter-item-active--Xdksq";
export var chapterListItem = "videoOverlay-module--chapter-list-item--qUy9W";
export var chapterMeta = "videoOverlay-module--chapter-meta--DqBFq";
export var chapterNumber = "videoOverlay-module--chapter-number--Mkzyb";
export var chapterPlayingIcon = "videoOverlay-module--chapter-playing-icon--AY0mp";
export var chapterTime = "videoOverlay-module--chapter-time--HoA25";
export var chapterTitle = "videoOverlay-module--chapter-title--clC1H";
export var chapterToolsContainer = "videoOverlay-module--chapter-tools-container--5FClL";
export var chaptersBtn = "videoOverlay-module--chapters-btn--E4e9g";
export var chaptersBtnIcon = "videoOverlay-module--chapters-btn-icon--zMhH4";
export var chaptersBtnInner = "videoOverlay-module--chapters-btn-inner--7A82m";
export var chaptersBtnLabel = "videoOverlay-module--chapters-btn-label--htmiu";
export var chaptersHeader = "videoOverlay-module--chapters-header--Ky5tr";
export var chaptersHeaderClose = "videoOverlay-module--chapters-header-close--ZWOIm";
export var chaptersHeaderCloseIcon = "videoOverlay-module--chapters-header-close-icon--52Cxx";
export var chaptersHeaderCount = "videoOverlay-module--chapters-header-count--gZqic";
export var chaptersHeaderLabel = "videoOverlay-module--chapters-header-label--NxV5i";
export var chaptersHeaderTitleGroup = "videoOverlay-module--chapters-header-title-group--1lsEo";
export var chaptersList = "videoOverlay-module--chapters-list--QtL6f";
export var chaptersPanel = "videoOverlay-module--chapters-panel--ihtmO";
export var chaptersScroll = "videoOverlay-module--chapters-scroll--9hcoJ";
export var close = "videoOverlay-module--close--4eUCq";
export var closeIcon = "videoOverlay-module--close-icon--WAxz1";
export var content = "videoOverlay-module--content--tLBmY";
export var currentChapter = "videoOverlay-module--current-chapter--nMS2h";
export var currentChapterLabel = "videoOverlay-module--current-chapter-label--qfrz+";
export var currentChapterTitle = "videoOverlay-module--current-chapter-title--dehFK";
export var dialog = "videoOverlay-module--dialog--y6m5a";
export var focusVisible = "videoOverlay-module--focus-visible--z+Xfq";
export var player = "videoOverlay-module--player--WiQJ9";
export var title = "videoOverlay-module--title--BtpgA";
export var tools = "videoOverlay-module--tools--JTs9j";
export var videoOverlayDialog = "videoOverlay-module--video-overlay-dialog--Yehsa";
export var videoOverlayPlayer = "videoOverlay-module--video-overlay-player--3vNeK";
export var wrapper = "videoOverlay-module--wrapper--luROJ";